<template>
  <div class="currency-detail">
    <Card v-if="$route.name == 'VCurrencyDetail'" :dis-hover="true" class="card-top">
      <Row :gutter="16" type="flex" justify="start" class="code-row-bg">
        <Col span="4">
          <span>学员昵称：{{ nickname }}</span>
        </Col>
        <Col span="4">
          <span>学员手机号：{{ mobile }}</span>
        </Col>
        <Col span="4">
          <span>当前金币余额：{{ remaining_sum }}</span>
        </Col>
        <Col span="4">
          <Button type="text" @click="handleEdit">修改金币</Button>
        </Col>
      </Row>
    </Card>
    <!-- <div class="info">
      <div class="item">
        <span class="label">用户姓名：</span>
        <span class="value">{{nickname}}</span>
      </div>
      <div class="item">
        <span class="label">用户手机号：</span>
        <span class="value">{{mobile}}</span>
      </div>
    </div>-->
    <Form :model="searchCondition" :label-width="70" inline>

      <FormItem style="float:right;">
        <span
          style="margin-right:10px"
          v-if="$route.name != 'VCurrencyDetail'"
        >当前金币余额：{{ integral_format }}</span>
        <Button v-if="$route.name != 'VCurrencyDetail'" @click="handleStuEdit" type="primary">修改金币</Button>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="'/api/balance/item/' + searchCondition.user_id"
        :search="searchCondition"
        :rowsFormatter="onRowsForamtter"
        selectType
        keyField
        method="get"
      >
        <template slot-scope="{ row }" slot="c1">
          【{{ type[row.type - 1].value }}】
          <span
            v-if="row.type != 4 && row.type != 5"
          >{{ row.remark }}</span>
          <span v-else>{{ row.shop_name }}{{ row.created_at }}</span>
          <!-- <p class="action-title">{{row.remark}}</p> -->
          <!-- <p class="action-content">{{row.shop_name}}</p> -->
        </template>
      </Grid>
    </div>
    <Modal title="修改金币" v-model="editGoldModal">
      <Form ref="form" :model="formInfo" :rules="rules" :label-width="100">
        <FormItem label="当前金币">{{ formInfo.integral }}</FormItem>
        <FormItem label="金币变化" prop="change_price">
          <InputNumber
            style="width:120px"
            :min="0 - formInfo.integral"
            v-model="formInfo.change_price"
            placeholder="-1表示减去1金币"
          />
          <span class="tag">金币</span>
          <span class="tag" style="color:#999;">
            <Icon type="ios-alert" size="15" color="#f7cb4b" />-1表示减去1金币
          </span>
        </FormItem>
        <FormItem label="修改缘由" prop="remark">
          <Input
            v-model="formInfo.remark"
            placeholder="请输入修改缘由，最多16个字"
            :maxlength="16"
            style="width:200px"
            clearable
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="editGoldModal = false">取消</Button>
        <Button type="primary" @click="handleSave">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "VCurrencyDetail",
  props: ["integral"],
  data() {
    return {
      searchCondition: {
        user_id: this.$route.query.user_id || this.$route.query.id,
        start_at: "",
        end_at: "",
        change_type: "",
        type: "",
        init() {
          this.start_at = "";
          this.end_at = "";
          this.change_type = "";
          this.type = "";
        }
      },
      rules: {
        change_price: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("价格不能为空"));
              } else {
                callback();
              }
            }
          }
        ],
        remark: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      nickname: this.$route.query.nickname,
      mobile: this.$route.query.mobile,
      remaining_sum: this.$route.query.remaining_sum,
      tableColumns: [
        { title: "时间", key: "created_at", align: "center", width: 170 },
        { title: "事件行为", slot: "c1" },
        { title: "变动类型", key: "change_type_format", width: 130 },
        { title: "金币变动", key: "change_price", align: "center", width: 170 },
        {
          title: "变动后余额",
          key: "remaining_sum",
          align: "center",
          width: 170
        }
      ],
      type: [
        { key: 1, value: "充值" },
        { key: 2, value: "购买课程" },
        { key: 3, value: "课程退款" },
        { key: 4, value: "购买约课" },
        { key: 5, value: "取消约课" },
        { key: 6, value: "平台增加" },
        { key: 7, value: "平台扣减" }
      ],
      formInfo: {
        integral: 0,
        change_price: 0,
        remark: ""
      },
      editGoldModal: false,
      integral_format: this.$pub.calcPrice(this.integral)
    };
  },
  created() {},
  watch: {
    integral(val) {
      this.integral_format = this.$pub.calcPrice(val);
    }
  },
  methods: {
    onDateRange(range) {
      this.searchCondition.start_at = range[0];
      this.searchCondition.end_at = range[1];
    },
    handleEdit() {
      this.formInfo.change_price = 0;
      this.formInfo.integral = Number(this.remaining_sum);
      this.formInfo.remark = "";
      this.editGoldModal = true;
    },
    handleStuEdit() {
      this.formInfo.change_price = 0;
      this.formInfo.integral = this.integral_format;
      this.formInfo.remark = "";
      this.editGoldModal = true;
    },
    handleSave() {
      console.log(typeof this.integral);
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$http
          .put(
            `/api/balance/${this.$route.query.user_id || this.$route.query.id}`,
            {
              change_price: this.formInfo.change_price,
              remark: this.formInfo.remark
            }
          )
          .then(() => {
            this.$Message.success("操作成功");
            this.remaining_sum =
              Number(this.remaining_sum) + this.formInfo.change_price;
            this.integral_format =
              typeof this.integral == "number"
                ? Number(this.formInfo.change_price) +
                  Number(this.integral_format)
                : "";
            this.editGoldModal = false;
            this.$router.push({
              query: {
                ...this.$route.query,
                remaining_sum:
                  typeof this.integral == "number"
                    ? this.integral_format
                    : this.remaining_sum
              }
            });
            this.$refs.grid.searchRefresh();
          });
      });
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.$refs.formDate.handleClear();
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    // on event
    onRowsForamtter(rows) {
      rows.forEach(i => {
        i.change_type_format = i.change_type == 1 ? "增加" : "减少";
        i.change_price = this.$pub.calcPrice(i.change_price);
        i.change_price = (i.change_type == 1 ? "+ " : "- ") + i.change_price;
        i.remaining_sum = this.$pub.calcPrice(i.remaining_sum);
        i.created_at = this.$pub.timestampToTime(i.created_at);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.currency-detail {
  .card-top {
    margin-bottom: 10px;
    span {
      vertical-align: sub;
    }
  }
  .info {
    .item {
      float: left;
      margin-right: 40px;
      .label {
        font-size: 13px;
      }
      .value {
        color: #999;
      }
    }
    &::after {
      content: "";
      display: block;
      clear: both;
    }
  }
  .content {
    .action-title {
      font-size: 13px;
    }
    .action-content {
      color: #999;
    }
  }
}
.tag {
  margin-left: 10px;
}
</style>
